import React from 'react';
import { Container } from 'react-bootstrap';
import shadmansaalim from '../../images/shadmansaalim.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserGraduate, faCode } from '@fortawesome/free-solid-svg-icons';
import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles

const About = () => {
    useEffect(() => {
        AOS.init({
            duration: 2500,
            once: false
        });
        AOS.refresh()
    }, [])

    return (
        <div id="about" className="pt-5" style={{ backgroundColor: 'black' }}>
            <div className="my-5">
                <Container style={{ overflowX: 'hidden' }}>
                    <h2 className="fw-bold text-white mb-5">More About Myself</h2>
                    <div className="row d-flex align-items-stretch" style={{
                        overflow: "hidden"
                    }}>
                        <img
                            data-aos="fade-right"
                            className="img-fluid col-lg-6 my-image"
                            src={shadmansaalim}
                            alt=""
                        />
                        <div className="col-lg-6 mt-4 mt-lg-0">
                            <div data-aos="fade-left" className="shadow-lg p-3 p-lg-5  rounded-3 text-white text-start" style={{
                                backgroundColor: '#141c3a'
                            }}>
                                <h3><span className="fw-bold">Work Experience</span> <FontAwesomeIcon icon={faUserGraduate} /></h3>
                                <h6 className="fw-bold">ProcessHQ</h6>
                                <ul>
                                    <li>Worked on Designing, building and testing in React.</li>
                                    <li>Worked across the full product including feature development, bug fixing, testing.</li>
                                    <li>Leaded the frontend development for the team.</li>
                                    <li>Debugged and tested software application.</li>
                                    <li>Created, designed, integrated software components and third-party programs.</li>
                                </ul>
                                <h6 className="fw-bold">TeammateMe</h6>
                                <ul>
                                    <li>Implemented new features assigned by Project Manager.</li>
                                    <li>Worked on PR Feedbacks, improved code and fixed bugs.</li>
                                    <li>Reviewed other developers code and gave feedbacks.</li>
                                    <li>Attended daily meetings.</li>
                                </ul>
                            </div>
                            <div data-aos="fade-up-left" className="shadow-lg mt-3 p-3 p-lg-5 rounded-3 text-white text-start bg-success" style={{
                                backgroundColor: '#413B65'
                            }}>
                                <h3><span className="fw-bold">Achievements & Education</span> <FontAwesomeIcon icon={faCode} /></h3>
                                <p>
                                    <ul>
                                        <li className="fw-bold">Second Place in Hack Melbourne 2022
                                            <a className="text-warning ms-2" target="_blank" rel="noreferrer" href="https://devpost.com/software/brevmod">Devpost
                                            </a>
                                        </li>
                                        <li className="fw-bold">Second Place in HackVision 2021 organized by Google
                                            <a className="text-warning ms-2" target="_blank" rel="noreferrer" href="https://devpost.com/software/byocc?ref_content=my-projects-tab&ref_feature=my_projects">Devpost
                                            </a>
                                        </li>

                                    </ul>
                                    I am a computer science student studying at RMIT University. I self-learned alongside my studies and gained real-world software engineering skills, which enabled me to land two jobs while being a full-time student. I am a full-stack developer specialising in the frontend. At this stage of my career, I am keeping myself focused on problem solving and have started focusing on DSA. My goal for 2022 would be to solve as many problems as possible.
                                </p>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </div>
    );
};

export default About;